import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { ApiDrop } from "@/generated/models/ApiDrop";
export function getIsDirectMessage(wave: {
  id: string;
}, fallback = false): boolean {
  const w = wave as {
    chat?: {
      scope?: {
        group?: {
          is_direct_message?: boolean;
        };
      };
    };
  };
  return w.chat?.scope?.group?.is_direct_message ?? fallback;
}
export function useWaveNavigation() {
  const $ = _c(8);
  const router = useRouter();
  const {
    isApp
  } = useDeviceInfo();
  let t0;
  if ($[0] !== isApp || $[1] !== router) {
    t0 = (waveId, serialNo, isDirectMessage) => {
      router.push(getWaveRoute({
        waveId,
        serialNo,
        isDirectMessage,
        isApp
      }));
    };
    $[0] = isApp;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const navigateToWave = t0;
  let t1;
  if ($[3] !== navigateToWave) {
    t1 = t2 => {
      const fallbackIsDm = t2 === undefined ? false : t2;
      return quote => {
        const quoteIsDm = getIsDirectMessage(quote.wave, fallbackIsDm);
        navigateToWave(quote.wave.id, quote.serial_no, quoteIsDm);
      };
    };
    $[3] = navigateToWave;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const createQuoteClickHandler = t1;
  let t2;
  if ($[5] !== createQuoteClickHandler || $[6] !== navigateToWave) {
    t2 = {
      navigateToWave,
      createQuoteClickHandler
    };
    $[5] = createQuoteClickHandler;
    $[6] = navigateToWave;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}